<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">{{ title }}</h3>
        </div>
        <div class="modal-body">
          <div class="list badgets mb-4 mt-0">
            <span class="item badget gray" v-for="(filter,i)  in filters" :key="`filter-item-${i}`">
              {{filter}}
            </span>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SearchResultModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    filters: {
      type: Array,
      default: []
    }
  },
}
</script>
<style scoped>
.list.badgets .badget.gray.item {
    padding: 0 22px;
    color: #323a45;
    background: #e0e1e3;
    border-radius: 8px;
    margin-right: 10px;
    margin-top: 10px;
    height: auto;
    text-align: -webkit-left;
}
</style>
